export default __webpack_public_path__ + "static/media/home-circles.c9f9f44f.svg";